/* @flow */

export const MARK_SPLASH_AS_SEEN = 'MARK_SPLASH_AS_SEEN';

export const COMPLETE_ONBOARDING_ON_DEVICE = 'COMPLETE_ONBOARDING_ON_DEVICE';
export const RESET_ONBOARDING_ON_DEVICE = 'RESET_ONBOARDING_ON_DEVICE';
